import "./clender.css"
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

export default function MyCalendar() {
  return (
<div className="clender">
    <FullCalendar
      plugins={[dayGridPlugin]}
      initialView="dayGridMonth"
      height="auto"
      events={[
        { title: "Meeting", date: "2026-01-20" },
        { title: "Deadline", date: "2026-01-25" }
      ]}
    />

</div>
    
  );
}
